import React from 'react';
import { useIntlBds } from '../../../../../translations/BdsIntlProvider';
import { Box } from '../../../../Box';
import { Grow } from '../../../../Grow';
import { Typography } from '../../../../Typography/Typography';
import { IconButton } from '../../../../IconButton';
import { Chip } from '../../../../Chip';
import { useDataTableContext } from '../../context/DataTableContext';
import { Grid } from '../../../../Grid';
import { useFilterState } from '../../utils/useFilterState';
import { ColumnsConfiguration } from './ColumnsConfiguration';
import { Filters } from './Filters';
import { Search } from './Search';

export const Toolbar: React.FC = () => {
  const { intl, format } = useIntlBds();
  const { tableInstance, slotProps, features, slots } = useDataTableContext();
  const { activeFilters, clearQueryModel, drawer } = useFilterState();

  const viewingMessage = format(intl.DataTable.Toolbar.totalCount, {
    totalCount: tableInstance.getRowCount(),
    pageDataCount: tableInstance.getCoreRowModel().rows.length
  });
  const addButtonProps = slotProps?.toolbar?.addButton;

  return (
    <React.Fragment key="toolbar">
      <Box key="toolbar-children">
        <Grid container spacing={2} alignItems="center" justifyContent="space-between">
          <Grid size="auto" container spacing={2} alignItems="center" justifyContent="flex-start">
            <Typography variant="body">{viewingMessage}</Typography>
            <Grid container spacing={2}>
              {slots?.filter?.toolbar?.activeFilters}
              {!slots?.filter?.toolbar?.activeFilters && !!activeFilters.length && (
                <Grow in>
                  <span>
                    <Chip
                      label={format(intl.DataTable.Filters.Active.activeFilters, {
                        activeFiltersLength: activeFilters.length,
                        filters: activeFilters.map((it) => it.label).join(', ')
                      })}
                      onClick={() => drawer.setOpen(true)}
                      onDelete={() => clearQueryModel()}
                    />
                  </span>
                </Grow>
              )}
            </Grid>
          </Grid>
          <Grid size="auto" container spacing={2} alignItems="center" justifyContent="flex-end">
            <Search />
            {slotProps?.toolbar?.beforeActions}
            {!!addButtonProps?.onClick && (
              <IconButton
                dataTest={addButtonProps.dataTest || 'data-table-add-button'}
                aria-label={addButtonProps.label || intl.DataTable.Toolbar.addButton.tooltipText}
                iconName={addButtonProps?.iconName ?? 'add'}
                disabled={addButtonProps.disabled}
                slotProps={{
                  tooltip: {
                    title: addButtonProps.label || intl.DataTable.Toolbar.addButton.tooltipText
                  }
                }}
                onClick={addButtonProps.onClick}
              />
            )}
            {slotProps?.toolbar?.afterActions}
            {features.columnManagement.enabled && <ColumnsConfiguration />}
            {!!slotProps?.filter?.elements && <Filters />}
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  );
};
